import React from 'react'
import PropTypes from 'prop-types'
import axios from 'axios'
import Loading from '../general/Loading.js'
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, BarChart, Bar, AreaChart, Area, ComposedChart, ReferenceLine, Label, LabelList} from 'recharts';
import BackwashTooltip from './BackwashTooltip.js'
import ChlorineTooltip from './ChlorineTooltip.js'
import SaturationIndexTooltip from './SaturationIndexTooltip.js'
import SingleTooltip from './SingleTooltip.js'
import WaterClarityTooltip from './WaterClarityTooltip.js'

class ChemicalRecordAnalytics extends React.Component {

  state = {
    selectedPoolId: this.props.pool_id,
    selectedStartDate:moment().subtract(14, 'days').format('YYYY-MM-DD'),
    selectedEndDate: moment().format('YYYY-MM-DD'),
    chemicalRecords: [],
    loading: true,
    selectedPool: {},
    imperialUnits: true
  }

  componentDidMount() {
    var that = this
    var today =  new Date()

    $('#pools').kendoComboBox({
        value: this.props.pool_id,
        dataTextField: 'location_and_pool_name',
        dataValueField: 'id',
        height: 300,
        dataSource: {
          transport: {
            read: '/pools.json?active=1&archived=0&include=location'
          },
          group: { field: 'location.name' }
        },

        change: function(e) {
          var value = e.sender.value()

          that.setState({
            selectedPoolId: value
          })

          that.buildData(value)
        }
    })

    var comboBox = $('#pools').data('kendoComboBox');
    if (comboBox) {
        var inputElement = comboBox.input;
        inputElement.attr({
            'aria-label': 'Select Pool',
            'role': 'combobox',
        });
    }

    $('#startDatePicker').kendoDatePicker({
      value: that.state.selectedStartDate,
      min: new Date(1950, 0, 1),
      max: today,

      change: function(e) {
        var value = e.sender.value()

        that.setState({
          selectedStartDate: value
        })

        that.buildData(that.state.selectedPoolId)
      }
    })

    $('#endDatePicker').kendoDatePicker({
      value: that.state.selectedEndDate,
      min: new Date(1950, 0, 1),
      max: today,

      change: function(e) {
        var value = e.sender.value()

        that.setState({
          selectedEndDate: value
        })

        that.buildData(that.state.selectedPoolId)
      }
    })

    const attachIconAccessibility = (inputId) => {
      const input = document.getElementById(inputId);
      if (!input) return;

      const wrapper = input.closest('.k-widget');
      if (!wrapper) return;

      const icon = wrapper.querySelector('.k-select');
      if (!icon) return;

      icon.setAttribute('tabindex', '0');
      icon.setAttribute('role', 'button');
      icon.setAttribute('aria-label', 'Open calendar for ' + inputId);

      icon.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          const picker = $(`#${inputId}`).data('kendoDatePicker');
          if (picker) {
            picker.open();

            // Wait for calendar popup and focus it
            setTimeout(() => {
              const calendarPopup = document.querySelector('.k-animation-container[style*="display: block"]');
              if (!calendarPopup) return;

              const focusable = calendarPopup.querySelector('[tabindex="0"]');
              if (focusable) {
                focusable.focus();
              }

              // Handle calendar close and return focus to next element
              const observer = new MutationObserver(() => {
                const stillOpen = document.querySelector('.k-animation-container[style*="display: block"]');
                if (!stillOpen) {
                  observer.disconnect();
                  // Move focus to next focusable element after the datepicker
                  const focusableElements = Array.from(document.querySelectorAll('input, button, [tabindex]:not([tabindex="-1"])'))
                    .filter(el => !el.disabled && el.offsetParent !== null);
                  const currentIndex = focusableElements.indexOf(input);
                  if (currentIndex > -1 && currentIndex + 1 < focusableElements.length) {
                    focusableElements[currentIndex + 1].focus();
                  }
                }
              });

              observer.observe(document.body, { childList: true, subtree: true });
            }, 0);
          }
        }
      });
    };

    attachIconAccessibility('startDatePicker');
    attachIconAccessibility('endDatePicker');

    this.buildData(that.state.selectedPoolId)
  }

  calculateColumnStatistics(chemicalRecords, column) {
    var that = this;
    var columnData = 0;
    if (column == "answers") {
      that.state.selectedPool.custom_fields
        .filter(customField => customField.field_type == 1)
        .forEach(customField => {
        columnData = _.compact(_.map(_.map(this.state.chemicalRecords, "answers"), customField.unique_title)).map(Number);

        that.setState({
          [customField.unique_title + '_min']: _.min(columnData),
          [customField.unique_title + '_max']: _.max(columnData),
          [customField.unique_title + '_avg']: _.mean(columnData)
        });
      });

    } else {
      columnData = _.compact(_.map(chemicalRecords, column).map(Number));

      that.setState({
        [column + '_min']: _.min(columnData),
        [column + '_max']: _.max(columnData),
        [column + '_avg']: _.mean(columnData)
      });
    };


  }

  calculateStatistics(chemicalRecords) {
    var that = this

    if (that.state.selectedPool.free_chlorine_ppm_toggle) {
      that.calculateColumnStatistics(chemicalRecords, 'free_chlorine_ppm')
    }

    if (that.state.selectedPool.total_chlorine_ppm_toggle) {
      that.calculateColumnStatistics(chemicalRecords, 'total_chlorine_ppm')
    }

    if (that.state.selectedPool.total_bromine_ppm_toggle) {
      that.calculateColumnStatistics(chemicalRecords, 'total_bromine_ppm')
    }

    if (that.state.selectedPool.hrr_orp_toggle) {
      that.calculateColumnStatistics(chemicalRecords, 'hrr_orp')
    }

    if (that.state.selectedPool.ph_toggle) {
      that.calculateColumnStatistics(chemicalRecords, 'ph')
    }

    if (that.state.selectedPool.alkalinity_toggle) {
      that.calculateColumnStatistics(chemicalRecords, 'alkalinity')
    }

    if (that.state.selectedPool.calcium_hardness_toggle) {
      that.calculateColumnStatistics(chemicalRecords, 'calcium_hardness')
    }

    if (that.state.selectedPool.air_temp_toggle) {
      that.calculateColumnStatistics(chemicalRecords, 'air_temp')
    }

    if (that.state.selectedPool.pool_temp_toggle) {
      that.calculateColumnStatistics(chemicalRecords, 'pool_temp')
    }

    if (that.state.selectedPool.custom_fields) {
      that.calculateColumnStatistics(chemicalRecords, 'answers')
    }

    if (that.state.selectedPool.alkalinity_toggle &&
        that.state.selectedPool.calcium_hardness_toggle &&
        that.state.selectedPool.ph_toggle) {
      that.calculateColumnStatistics(chemicalRecords, 'si_index')
    }

    that.setState({ loading: false })
  }

  getChemicalRecords() {
    var that = this
     
    var params = {
      pool_id: this.state.selectedPoolId,
      start: this.state.selectedStartDate,
      end: this.state.selectedEndDate,
      order_by: 'time_stamp',
      order_dir: 'desc'
    }

    that.setState({
      chemicalRecords: []
    })

    that.setState({
      loading: true
    })

    axios({
      method:'get',
      url:'/chemical_records.json',
      params: params,
      responseType:'json'
    })
    .then(function(response) {
      _.forEach(response.data, function(chemicalRecord) {
        chemicalRecord.createdAt =  moment(chemicalRecord.time_stamp).format('M/D/YYYY @ h:mma')
        chemicalRecord.name = moment(chemicalRecord.time_stamp).format('M/D')
        chemicalRecord.employee = chemicalRecord.user ? chemicalRecord.user.full_name_reverse : 'Deleted User'

        if (chemicalRecord.backwash) {
          chemicalRecord.backwashValue = 2
        }
        else {
          chemicalRecord.backwashValue = 1
        }

        if (chemicalRecord.water_clarity == 'Clear') {
          chemicalRecord.waterClarityValue = 2
        }
        else {
          chemicalRecord.waterClarityValue = 1
        }
      })

      that.setState({ chemicalRecords: response.data })
      that.calculateStatistics(response.data)
    })
  }

  buildData(poolId) {
    var that = this
    
    axios({
      method:'get',
      url:'/pools/' + poolId + '.json',
      responseType:'json'
    })
    .then(function(response) {

      that.setState({
        selectedPool: response.data,
        imperialUnits: response.data.account.imperial_units 
      })
      // that.state.selectedPool.account.imperial_units ? 'Pool Temp (F)' : 'Pool Temp (C)';

      that.getChemicalRecords()
    })
    .catch(function (error) {
      console.log(error)

      that.setState({
        chemicalRecords: []
      })

      toastr.error('Pool does not exist')
    });
  }

  renderSingleChart(data, dataKey, name) {
    var that = this

    if (that.state[dataKey + '_min'] <= (that.state[dataKey + '_max']*1.5)) {
      var minDomain = that.state[dataKey + '_min']
      var maxDomain = that.state[dataKey + '_max']
    }
    else {
      var minDomain = 'auto'
      var maxDomain = 'auto'
    }

    return(
      <div className='well shadowDepth1'>
        <ResponsiveContainer width='100%' height={250}>
          <LineChart data={data} syncId='all'>
            <XAxis dx={-3} dataKey='name' reversed={true} tick={{ fill: '#424242' }} dot={{ stroke: 'red', strokeWidth: 2 }} />
            <YAxis dy={-3} axisLine={false} orientation='left' tick={{ fill: '#424242' }} type='number' allowDataOverflow domain={[minDomain, maxDomain]} />
            <Tooltip content={<SingleTooltip/>} />
            <Legend height={40} align='left' verticalAlign='top' />
            <CartesianGrid vertical={false} stroke='#f5f5f5' />
            <ReferenceLine y={that.state[dataKey + '_avg']} stroke='#E82B65' strokeDasharray='3 3' label={{ position: 'top',  value: 'AVG', fill: '#E82B65' }} />
            <Line name={name} connectNulls={false} type='linear' dataKey={dataKey} stackId='1' stroke='#3A458E' strokeWidth='3' />
          </LineChart>
        </ResponsiveContainer>
      </div>
    )
  }

  renderSIChart(data, dataKey, name) {
    var that = this

    if (that.state[dataKey + '_min'] <= (that.state[dataKey + '_max']*1.5)) {
      var minDomain = that.state[dataKey + '_min']
      var maxDomain = that.state[dataKey + '_max']
    }
    else {
      var minDomain = 'auto'
      var maxDomain = 'auto'
    }

    return(
      <div className='well shadowDepth1'>
        <ResponsiveContainer width='100%' height={250}>
          <LineChart data={data} syncId='all'>
            <XAxis dx={-3} dataKey='name' reversed={true} tick={{ fill: '#424242' }} />
            <YAxis dy={-3} axisLine={false} orientation='left' tick={{ fill: '#424242' }} type='number' allowDataOverflow domain={[minDomain, maxDomain]} />
            <Tooltip content={<SaturationIndexTooltip/>} />
            <Legend height={40} align='left' verticalAlign='top' />
            <CartesianGrid vertical={false} stroke='#f5f5f5' />
            <ReferenceLine y={that.state.si_index_avg} stroke='#E82B65' strokeDasharray='3 3' label={{ position: 'top',  value: 'AVG', fill: '#E82B65' }} />
            <Line name='Langelier Saturation Index (LSI)' connectNulls={false} type='linear' dataKey='si_index' stackId='1' stroke='#3A458E' strokeWidth='3' />
          </LineChart>
        </ResponsiveContainer>
      </div>
    )
  }

  waterClarityLabel(cr) {
    if (cr.waterClarityValue == 2) {
      return('Clear')
    }
    else {
      return('Cloudy')
    }
  }

  renderWaterClarityChart(data, dataKey, name) {
    var that = this;

    return(
      <div className='well shadowDepth1'>
        <ResponsiveContainer width='100%' height={250}>
          <BarChart data={data} syncId='all'>
            <XAxis dx={-3} dataKey='name' reversed={true} tick={{ fill: '#424242' }} />
            <YAxis dy={-3} axisLine={false} orientation='left' tick={{ fill: '#424242' }} type='number' domain={[0, 3]} ticks={['Clear']} />
            <CartesianGrid vertical={false} stroke='#f5f5f5'/>
            <Tooltip content={<WaterClarityTooltip/>} />
            <Legend height={40} align='left' verticalAlign='top' />
            <Bar name={name} dataKey={dataKey} fill='#3A458E'>
              <LabelList position='center' angle={-60} stroke='#f5f5f5'
                valueAccessor={(cr) => that.waterClarityLabel(cr)}
              />
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    );
  }

  backwashLabel(cr) {
    if (cr.backwashValue == 2) {
      return('Yes')
    }
    else {
      return('No')
    }
  }

  renderBackwashChart(data, dataKey, name) {
    var that = this;

    return(
      <div className='well shadowDepth1'>
        <ResponsiveContainer width='100%' height={250}>
          <BarChart data={data} syncId='all'>
            <XAxis dx={-3} dataKey='name' reversed={true} tick={{ fill: '#424242' }} />
            <YAxis dy={-3} axisLine={false} orientation='left' tick={{ fill: '#424242' }} type='number' domain={[0, 3]} ticks={['Yes']} />
            <CartesianGrid vertical={false} stroke='#f5f5f5' />
            <Tooltip content={<BackwashTooltip/>} />
            <Legend height={40} align='left' verticalAlign='top'/>
            <Bar name={name} dataKey={dataKey} fill='#3A458E'>
              <LabelList position='center' angle={-60} stroke='#f5f5f5'
                valueAccessor={(cr) => that.backwashLabel(cr)}
              />
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    );
  }

  emptyTooltip() {
    return (
      <span></span>
    )
  }

  render() {
    var that = this;
    return(
      <div>
        <h1>Chemical Record Analytics</h1>
        <div className="row">
          <br className="visible-xs" />
          <div className="col-xs-12 col-md-6">
          <input id="pools" className="full-width" />
            <br className="visible-xs visible-sm" />
            <br className="visible-xs visible-sm" />
          </div>
          <div className="col xs-12 col-md-3">
            <input id="startDatePicker" className="full-width" aria-label="Start Date"/>
            <br className="visible-xs visible-sm" />
            <br className="visible-xs visible-sm" />
          </div>
          <div className="col xs-12 col-md-3">
            <input id="endDatePicker" className="full-width" aria-label="End Date" />
          </div>
        </div>
        <br />
        {(that.state.chemicalRecords && that.state.chemicalRecords.length) ? (
          <div>
            {(that.state.selectedPool.free_chlorine_ppm_toggle && that.state.selectedPool.total_chlorine_ppm_toggle) &&
              <div className='well shadowDepth1'>
                <ResponsiveContainer width='100%' height={250}>
                  <BarChart data={that.state.chemicalRecords} syncId='all'>
                    <XAxis dx={-3} dataKey='name' reversed={true} tick={{ fill: '#424242' }} />
                    <YAxis dy={-3} axisLine={false} orientation='left' tick={{ fill: '#424242' }} />
                    <Tooltip content={<ChlorineTooltip/>} />
                    <Legend height={40} align='left' verticalAlign='top' />
                    <CartesianGrid vertical={false} stroke='#f5f5f5' />
                    <Bar name='Free Chlorine (PPM)' dataKey='free_chlorine_ppm' stackId='cl' fill='#45519E' />
                    <Bar name='Combined Chlorine (PPM)' dataKey='combined_chlorine_ppm' stackId='cl' fill="#D43964" />
                  </BarChart>
                </ResponsiveContainer>
                <br />
                <ResponsiveContainer width='100%' height={125}>
                  <LineChart data={that.state.chemicalRecords} syncId='all'>
                    <XAxis dx={-3} reversed={true} dataKey='name' hide={true} />
                    <YAxis dy={-3} orientation='left' tick={{ fill: '#424242' }} />
                    <CartesianGrid vertical={false} stroke='#f5f5f5' />
                    <Tooltip content={this.emptyTooltip} />
                    <Legend align='left' verticalAlign='bottom' height={20} />
                    <ReferenceLine y={that.state.total_chlorine_ppm_avg} stroke='#E82B65' strokeDasharray='3 3' label={{ position: 'top',  value: 'AVG', fill: '#E82B65' }}/>
                    <Line name='Total Chlorine (PPM)' connectNulls={true} type='linear' dataKey='total_chlorine_ppm' stackId='1' stroke='#3A458E' strokeWidth='3' />
                  </LineChart>
                </ResponsiveContainer>
              </div>
            }

            {(that.state.selectedPool.free_chlorine_ppm_toggle && !that.state.selectedPool.total_chlorine_ppm_toggle) &&
              <span>
                {that.renderSingleChart(that.state.chemicalRecords, 'free_chlorine_ppm', 'Free Chlorine (PPM)')}
              </span>
            }

            {(!that.state.selectedPool.free_chlorine_ppm_toggle && that.state.selectedPool.total_chlorine_ppm_toggle) &&
              <span>
                {that.renderSingleChart(that.state.chemicalRecords, 'total_chlorine_ppm', 'Total Chlorine (PPM)')}
              </span>
            }

            {that.state.selectedPool.total_bromine_ppm_toggle &&
              <span>
                {that.renderSingleChart(that.state.chemicalRecords, 'total_bromine_ppm', 'Total Bromine (PPM)')}
              </span>
            }

            {that.state.selectedPool.ph_toggle &&
              <span>
                {that.renderSingleChart(that.state.chemicalRecords, 'ph', 'pH')}
              </span>
            }

            {that.state.selectedPool.alkalinity_toggle &&
              <span>
                {that.renderSingleChart(that.state.chemicalRecords, 'alkalinity', 'Alkalinity')}
              </span>
            }

            {that.state.selectedPool.calcium_hardness_toggle &&
              <span>
                {that.renderSingleChart(that.state.chemicalRecords, 'calcium_hardness', 'Calcium Hardness')}
              </span>
            }

            {that.state.selectedPool.hrr_orp_toggle &&
              <span>
                {that.renderSingleChart(that.state.chemicalRecords, 'hrr_orp', 'HRR / ORP')}
              </span>
            }

            {(that.state.selectedPool.air_temp_toggle) &&
              <span>
                {that.renderSingleChart(that.state.chemicalRecords, 'air_temp', (that.state.imperialUnits ? 'Air Temp (F)' : 'Air Temp (C)' ))}
              </span>
            }

            {(that.state.selectedPool.pool_temp_toggle) &&
              <span>
                {that.renderSingleChart(that.state.chemicalRecords, 'pool_temp', (that.state.imperialUnits ? 'Pool Temp (F)' : 'Pool Temp (C)' ))}
              </span>
            }

            {(that.state.selectedPool.water_clarity_toggle) &&
              <span>
                {that.renderWaterClarityChart(that.state.chemicalRecords, 'waterClarityValue', 'Water Clarity')}
              </span>
            }

            {(that.state.selectedPool.pool_temp_toggle && that.state.selectedPool.calcium_hardness_toggle && that.state.selectedPool.alkalinity_toggle) &&
              <span>
                {that.renderSIChart(that.state.chemicalRecords)}
              </span>
            }

            {that.state.selectedPool.backwash_toggle &&
              <span>
                {that.renderBackwashChart(that.state.chemicalRecords, 'backwashValue', 'Backwash')}
              </span>
            }

            {that.state.selectedPool.custom_fields
              .filter(customField => customField.field_type == 1)
              .map(customField => {
                return(
                  <span>
                    {that.renderSingleChart(_.map(that.state.chemicalRecords, "answers"), customField.unique_title, customField.label)}
                  </span>
                )
              })
            }
          </div>
        ) : (
          <Loading loading={this.state.loading}
                   noDataMessage='No chemical records' />
        )}
      </div>
    )
  }
}

ChemicalRecordAnalytics.propTypes = {
  pool_id: PropTypes.string
}

export default ChemicalRecordAnalytics
